import ArticleVariable from './ArticleVariable'

export default ArticleVariable
